<template>
	<div class="button-group" :class="{ wall }">
		<slot />
	</div>
</template>

<script>
export default {
	name: 'ButtonGroup',
	props: {
		wall: Boolean
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/layout';
@import '~scss/components';
@import '~scss/mq';

@mixin button-group($width) {
	@extend %flex-col;
	width: $width;
	margin: 2rem auto;
	align-items: stretch;

	> * {
		width: $width;
		text-align: center;
	}

	@include not-last {
		margin-bottom: 1rem;
	}

	@include mq(lg) {
		flex-direction: row;
		width: auto;
		justify-content: center;

		@include not-last {
			margin-right: 1rem;
			margin-bottom: 0;
		}
	}
}

.button-group {
	&:not(.wall) {
		@include button-group(18rem);
	}
	&.wall {
		@include button-group(22rem);
	}
}
</style>
